// eslint-disable  prefer-arrow/prefer-arrow-functions
import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Breed } from '@models/Breed';

export function createInititalState(): Breed[] {
	return [];
}

export interface BreedsState extends EntityState<Breed, number> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'breeds' })
export class BreedsStore extends EntityStore<BreedsState> {
	constructor() {
		super();
	}
}
